module.exports = __webpack_public_path__ + "img/4.283838d6.jpg";